'use strict';
define([
    "dojo/_base/declare",
    "mw-filebrowser/actions/Action",
    "dojo/i18n!nls/mldoStringResource",
], function (declare, Action, MLDOStrings) {
  return declare(Action, {
    constructor: function (args) {
        args = args || {};
        var context = args.context;
        var makeActionAvailable = args.showAction || false;
        this.name =  "shareLinkAction";
        this.enabled = makeActionAvailable;
        this.getInvitationDetailsMethod = args.getInvitationDetailsMethod;
        this.label = MLDOStrings.contextMenuShareLinkLabel;
        this.section = {
          id: "MISC",
          name: "MISC",
          allowSubMenu: false,
          forceSubMenu: false
        };
        this.isApplicableTo = function () {
            let invitationType;
            let invitationAccessType;
            if (this.getInvitationDetailsMethod && typeof this.getInvitationDetailsMethod === "function" && this.getInvitationDetailsMethod()) {
                invitationType = this.getInvitationDetailsMethod().invitationType;
                invitationAccessType = this.getInvitationDetailsMethod().invitationAccessType;
            }
            // Disable for personal invitations unless owned by self
            if (invitationType !== "PERSONAL" || invitationAccessType === "OWNER") {
                this.enabled = makeActionAvailable && true;
            } else {
                this.enabled =  false;
            }
            return this.enabled;
        };
        this.callback = function () {
          if (this.isApplicableTo()) {
            let invitationDetails;
            if (this.getInvitationDetailsMethod && typeof this.getInvitationDetailsMethod === "function" && this.getInvitationDetailsMethod()) {
              invitationDetails = this.getInvitationDetailsMethod();
            }
            let path;
            let selectedFileCount = context.getSelectedRowCount();
            let cwd = context.getCurrentFolder()
            if (selectedFileCount === 0 || selectedFileCount > 1) {
              path = cwd;
            } else {
              path = cwd !== "/" ? cwd + context.getSelectedItemFileInfos()[0].path : context.getSelectedItemFileInfos()[0].path;
            }
            if (invitationDetails && typeof invitationDetails === "object") {
              context.handlePreviewShareLinkAction(invitationDetails.invitationId, path);
            }
          }
        };
    }
  });

});
